import { font, spacing, colors } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { SecondaryButton } from '@chegg-ui/button'
import styled, { css } from 'styled-components'
import {
  ModalContent as BaseModalContent,
  Container,
  CloseButton as BaseCloseButton,
} from '../styled'

const buttonOverflowFix = css`
  /**
   * [1]: counteract scale(1.05) applied on hover to prevent overflow issue
   */
  width: auto;
  max-width: calc(100% / 1.05); /* [1] */
`

export const ModalContent = styled(BaseModalContent)`
  padding: 32px 0px 10px 0px;
`

export const CloseButton = styled(BaseCloseButton)`
  top: 0.5rem;
  right: 0.5rem;
`

export const TitleText = styled.h2`
  font-size: ${font.size.px32};
  font-weight: bold;
  text-align: center;
  margin: ${spacing.px16} ${spacing.px96};
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    font-size: ${font.size.px28};
    margin: ${spacing.px16} ${spacing.px32};
  }
`

export const ContentContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ContinueButton = styled(SecondaryButton).attrs({
  variant: 'outlined',
})`
  ${buttonOverflowFix};

  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};

  &&&:hover {
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    color: ${colors.white};
    box-shadow: 0 0 0 0.13rem ${({ theme }) => theme.Colors.forInterface.interfaceColor01}
      inset;
  }

  &&&:active {
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
    box-shadow: 0 0 0 0.13rem ${({ theme }) => theme.Colors.forInterface.interfaceColor01}
      inset;
  }

  && {
    color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
    box-shadow: 0 0 0 0.13rem ${({ theme }) => theme.Colors.forInterface.interfaceColor01}
      inset;
  }
`
